const usersData = (state) => state.data.users;
const usersMetadata = (state) => state.users;

export const users = usersData;
export const user = (state, id) => usersData(state)[id];

export const fetchingUsers = (state) => usersMetadata(state).fetchingUsers;

export const fetchingUser = (state, id) => !!fetchingUsers(state)[id];
